import * as Style from '../Kyc.styles';
import * as Text from 'styles/text';

import {
  politicallyOptions,
  politicallyOptionsPT,
  politicallyOptionsSP,
} from '~/data/others';
import { useEffect, useMemo, useState } from 'react';

import { ReactComponent as CardIcon } from 'assets/images/icons/card.svg';
import Footer from 'components/Footer';
import Header from 'components/Header';
import { SelectRadio } from 'components';
import { StepProps } from '../Kyc.types';
import { useFormContext } from 'react-hook-form';
import { useProgressBar } from '~/store';
import { useTranslation } from 'react-i18next';
import { userId } from '~/services/url';

export default function PoliticallyExposed({ goToStep }: StepProps) {
  const { setValue, watch } = useFormContext();

  const [selectedExposed, setSelectedExposed] = useState(
    watch('politicallyExposed') || ''
  );

  const { t, i18n } = useTranslation();
  const { setProgressPct, totalOfSteps } = useProgressBar();

  const politicallyExposedQuestions = useMemo(() => {
    let list = [];
    switch (i18n.language) {
      case 'es-ES':
        list = politicallyOptionsSP;
        break;

      case 'en-US':
        list = politicallyOptions;
        break;

      default:
        list = politicallyOptionsPT;
        break;
    }

    return list;
  }, [i18n.language]);

  const userUuid = userId()

  useEffect(() => {
     // @ts-ignore
     gtag('event', 'screen_view', {
      'screen_name': 'politically_exposed_step',
      userId: userUuid
    });
    setProgressPct((4 / totalOfSteps) * 100);
  }, []);

  useEffect(() => {
    setValue('politicallyExposed', selectedExposed);
  }, [selectedExposed, setValue]);

  return (
    <Style.StepContent>
      <Header label="Personal Data" icon={<CardIcon />} />

      <Text.Heading1Medium fontSize={1.938} marginTop={24} marginBottom={24}>
        {t('Are you politically exposed?')}
      </Text.Heading1Medium>

      {politicallyExposedQuestions.map((c) => (
        <SelectRadio
          key={c.value}
          label={t(c.label)}
          checked={c.value === selectedExposed}
          onChange={() => setSelectedExposed(c.value)}
          name="monthlyIncome"
        />
      ))}

      <Footer
        onClickLeftButton={() => goToStep('formIncome')}
        leftButtonContent={t('Back')}
        onClickGenericButton={() => goToStep('next')}
        disableGenericButton={!watch('politicallyExposed')}
        genericButtonType="secondary"
        genericButtonContent={t('Continue')}
      />
    </Style.StepContent>
  );
}
